import { render, staticRenderFns } from "./TransporteCollapse.vue?vue&type=template&id=1b4a30ed&scoped=true&"
import script from "./TransporteCollapse.vue?vue&type=script&lang=js&"
export * from "./TransporteCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4a30ed",
  null
  
)

export default component.exports